import React, {useEffect, useState} from "react";
import {Button, Image, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Spinner} from "react-bootstrap";
import {isCardDesignTemp, isMessageTemp, isWrapTemp} from "../const/TemplateConst";
import {OptionTemplateItem} from "../components/list/OptionTemplateItem";
import "../../style/modal/_template_list_modal.scss";
import {url} from "../utils/UrlsUtil";
import {post} from "../utils/FetchUtil.ts";
import {img} from "../utils/ImageUtil.ts";
import {popErrors} from "../utils/MessageUtil.ts";

interface TemplateListModalProps{
    show: boolean;
    search_dto: OrderInputTemplateDto | null | undefined;
    handleClosed: () => void;
    handleSelected: ( dto: OrderInputTemplateDto ) => void;
}

const TemplateListModal:React.FC<TemplateListModalProps> = ({
    show = false,
    search_dto = undefined,
    handleClosed = () => {},
    handleSelected = () => {}
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [templateList, setTemplateList] = useState<OrderInputTemplateDto[] | undefined | null>(undefined);
    const [templateTitle, setTemplateTitle] = useState<string>("");
    const fetchTemplates = (dto: OrderInputTemplateDto) => {
        setIsLoading(true);
        post<OrderInputTemplateDto[]>({
            action: "/api/template/list",
            data: dto,
        })
            .then((data) => {
                setTemplateList(data);
            })
            .catch((reason) => {
                console.log(reason);
                setTemplateList([]);
            })
            .finally(() => {setIsLoading(false)});
    };
    useEffect(() => {
        if(!search_dto) {
            setTemplateList(undefined);
            return;
        }
        if(isWrapTemp(search_dto.template_kbn)){
            setTemplateTitle("のし・包装の選択");
        }else if(isCardDesignTemp(search_dto.template_kbn)){
            setTemplateTitle("オリジナルギフトカードの選択");
        }else if(isMessageTemp(search_dto.template_kbn)){
            setTemplateTitle("オンラインメッセージの選択");
        }
        fetchTemplates(search_dto);
    }, [search_dto]);
    const onClickInputButton = () => {
        if(isLoading){
            return;
        }
        if(search_dto){
            handleSelected({
                template_id: -1,
                template_kbn: search_dto.template_kbn,
                order_slipnumber: search_dto.order_slipnumber,
                order_detailnumber: search_dto.order_detailnumber
            });
        }
    }
    const handleEntryResult = (dto: OrderInputTemplateDto) => {
        if(isLoading){
            return;
        }
        if(search_dto?.template_id && dto.result_template_id && dto.result_template_id === search_dto?.template_id){
            handleClosed();
        }else{
            setIsLoading(true);
            post<OrderInputTemplateDto>({
                action: "/api/template/entry/result",
                data: dto,
            })
                .then((data) => {
                    if(data !== null && data !== undefined) {
                        handleSelected(data);
                    }
                })
                .catch((reason) => {
                    popErrors(reason.message);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };
  return (
      <Modal className="template-list-modal" show={show} onHide={handleClosed} centered>
          <ModalHeader closeButton>
              <ModalTitle><img src={url("/images/logo/geeva_logo.png")}/></ModalTitle>
          </ModalHeader>
          <ModalBody>
              <h2>{templateTitle}</h2>
              {isLoading && (
                  <div className="d-flex justify-content-center align-items-center position-absolute w-100 h-100"
                       style={{ top: 0, left: 0, backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 10 }}>
                      <Spinner animation="border" variant="secondary" />
                  </div>
              )}
              {isCardDesignTemp(search_dto?.template_kbn)?
                  <section className="ondemand-card-template-area">
                      {(!templateList || templateList.length == 0) ? (
                          !isLoading && <h3 className="text-danger mt-5">データがありません、登録してください。</h3>
                          ) : (
                              <div className="templates-wrap-list ondemand-card-template-list">
                                  {templateList.map((temp, idx) =>
                                      <Image key={`ondemand_card_tmp_itm_${idx}`}
                                             className="ondemand-card-template-item"
                                          //@ts-ignore
                                             src={img(temp.image_path)}
                                             fluid={true}
                                             onClick={() => {handleEntryResult(temp)}}/>
                                  )}
                            </div>
                      )}
              </section>
              : <section className="templates-area">
                      {(templateList && templateList.length > 0) ?
                          <div className="templates-wrap-list">
                              {templateList.map((temp, idx) =>
                                  <OptionTemplateItem key={`template_list_item_${idx}`}
                                                      template_dto={temp}
                                                      handleClick={() => {handleEntryResult(temp)}}
                                  />)}
                          </div>
                          : (!isLoading && <h3 className="text-danger mt-5">データがありません、登録してください。</h3>)
                      }
                  </section>}
          </ModalBody>
          <ModalFooter>
              <Button variant="info btn-entry"
                      onClick={onClickInputButton}
                      disabled={isLoading}
              >
                  マイデザイン作成へ
              </Button>
              <Button variant="secondary"
                      onClick={handleClosed}>
                  閉じる
              </Button>
          </ModalFooter>
      </Modal>
  );
};
export default TemplateListModal;